import { Document } from "@/types/models";

export const ALL_TAB = "All";
export const ALL_SOURCE_TYPES = "All Types";
export const ALL_EVIDENCE_TYPES = "All Evidence Types";

/** The only ownership values the UI shows; anything else is legacy. */
export const SELECTABLE_OWNERSHIPS = ["client", "private"];

export const isSelectableOwnership = (doc: Document) =>
  SELECTABLE_OWNERSHIPS.includes(doc.ownership?.toLowerCase() ?? "");

export const matchesSourceTypeTab = (doc: Document, tab: string) => doc.sourceType === tab;

/**
 * Untyped documents get no tab of their own, so the category counts sum to less
 * than All whenever any document is missing a source type.
 */
export const buildSourceTypeTabs = (docs: Document[]) => [
  ALL_TAB,
  ...new Set(docs.filter((d) => d.sourceType).map((d) => d.sourceType)),
];

/** All counts every visible row, typed or not. Must be fed the same set the grid renders. */
export const countForTab = (docs: Document[], tab: string) =>
  tab === ALL_TAB ? docs.length : docs.filter((d) => matchesSourceTypeTab(d, tab)).length;
